export const cartOrderSummaryAction = (data) =>{
    return {
        type:"CART_ORDER_SUMMARY",
        payload:data
    };
};
export const cartVariantAction = (data) =>{
    return {
        type:"CART_VARIANT",
        payload:data
    };
};
export const cartPackAction = (data) =>{
    return {
        type:"CART_PACK",
        payload:data
    };
};
export const cartOfferAction = (data) =>{
    return {
        type:"CART_OFFER",
        payload:data
    };
};
export const paymentOfferAction = (data) =>{
    return {
        type:"PAYMENT_OFFER",
        payload:data
    };
};
export const cartAppliedOfferAction = (data) =>{
    return {
        type:"CART_APPLIED_OFFER",
        payload:data
    };
};

export const couponModalOpenAction = (data) =>{
    return {
        type:"COUPON_MODAL_OPEN",
        payload:data
    };
};

export const cartHeaderSummaryAction = (data) =>{
    return {
        type:"CART_HEADER_SUMMARY",
        payload:data
    };
};
export const cartAddressAction = (data) =>{
    return {
        type:"CART_ADDRESS",
        payload:data
    };
};

export const appliedMBCashChangeAction = (data) =>{
    return {
        type:"MB_CASH_TOGGLE",
        payload:data
    };
};
export const orderSummaryPopUpAction = (data) =>{
    return {
        type:"ORDER_SUMMARY_POPUP",
        payload:data
    };
};

export const offerApplyModalAction = (data) =>{
    return {
        type:"OPEN_OFFER_APPLY_MODAL",
        payload:data
    };
};

export const vitaPointChangeAction = (data) =>{
    return {
        type:"VITA_POINTS_CHANGE",
        payload:data
    };
};

export const crossOfferListAction = (data) =>{
    return {
        type:"CROSS_OFFER_LIST",
        payload:data
    };
};

export const selectedCrossOfferAction = (data) =>{
    return {
        type:"SELECT_CROSS_OFFER",
        payload:data
    };
};

export const wishtListCountAction = (data) =>{
    return {
        type:"WISH_LIST_COUNT",
        payload:data
    };
};